import { Box, Button, Grid, Typography } from '@mui/material';

import './UpgradeBusinessBanner.css';

const UpgradeBusinessBanner = () => {
    return (
        <Grid container className="banner-container">
            <Grid item md={2} xs={2}>
                <Box className="falling-paystand-cards-section">
                    <Box className="falling-paystand-cards-img" component="img" alt="TiltedCardsLogo" src="img/TiltedCards.png" />
                </Box>
            </Grid>
            <Grid item md={7} xs={10} alignSelf="center">
                <Typography className="upgrade-business-banner-info-title">
                    Upgrade your business to a DeFi Corporate Card Account and earn bitcoin today
                </Typography>
                <Typography noWrap className="upgrade-business-banner-info-subtitle">
                    Get started in less than{' '}
                    <Box component="span" fontWeight="bold">
                        5 minutes
                    </Box>
                </Typography>
            </Grid>
            <Grid item md={3} xs={12} position="relative">
                <Box className="apply-now-btn-container">
                    <Button
                        variant="contained"
                        href="https://www.paystand.com/technology/crypto-rewards?utm_source=DeFi+Card+Gift+Card%24utm_medium=Gift+Card"
                        target="_blank">
                        Apply Now
                    </Button>
                </Box>
                <Box className="falling-bitcoins-section">
                    <Box className="falling-bitcoins-container">
                        <Box className="falling-bitcoins-img" component="img" alt="BitLogos" src="img/BitLogos.png" />
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default UpgradeBusinessBanner;
